<template>

  <table class="table table-striped w-100" :id="nombreTabla">
    <template v-if="psCharterCreateMode">
      <fieldset-component texto="Agregar nuevo plan semanal" class="mb-3 mt-3" />
      <tr>
        <td>
          <ui-select
            placeholder="Seleccionar cliente"
            hasSearch
            v-model="client_model"
            :options="psCharterListaClientes"
            :keys="{ value: 'id', label: 'name' }"
          />
        </td>
        <td>
          <select class="form-control" v-model="week_model">
            <option value="">Seleccione una opción</option>
            <option v-for="(week, week_index) in psCharterCurrentWeeks" :key="week_index" :value="week">
              {{ week }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="port_model">
            <option value="">Seleccione una opción</option>
            <option v-for="(pod, pod_index) in psCharterListaPuertos" :key="pod_index" :value="pod.id">
              {{ pod.name }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="specie_model">
            <option value="">Seleccione una opción</option>
            <option v-for="(specie, specie_index) in psCharterListaEspecies" :key="specie_index" :value="specie.id">
              {{ specie.name }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="pallet_model">
            <option value="">Seleccione una opción</option>
            <option v-for="(pallet, pallet_index) in psCharterListaPallets" :key="pallet_index" :value="pallet.id">
              {{ pallet.name }}
            </option>
          </select>
        </td>
        <td>
          <input class="form-control" type="text" placeholder="Ingrese una cantidad..." v-model="quantity_model"
                 v-mask="'####'" />
        </td>
        <td>
          <div class="text-center">
            <a class="btn btn-sm icono" @click="saveNewPlan">
              <i title="Guardar plan" class="fa fa-save"
                 style="text-align: center; font-size: 11.7px;"></i>
            </a>
            <a class="btn btn-sm icono" @click="cancelNewPlan">
              <i title="Cancelar" class="fa fa-times text-danger" style="text-align: center; font-size: 11.7px;"></i>
            </a>
          </div>
        </td>
      </tr>
      <fieldset-component texto="Planes semanales existentes" class="mb-3 mt-3" />
    </template>
    <thead>
    <tr>
      <template>
        <th class="text-md-break">Cliente</th>
        <th class="text-md-break">Semana</th>
        <th class="text-md-break">POD</th>
        <th class="text-md-break">Especie</th>
        <th class="text-md-break">Pallet</th>
        <th class="text-md-break">Cantidad</th>
        <th class="text-md-break">Acciones</th>
      </template>
    </tr>
    </thead>
    <tbody>
    <template>
      <tr v-for="(row, index) in data" :key="index">
        <td>
          <select class="form-control" v-model="row.client_id"
                  :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex"
                  @change="actionSetEditingRowIndexPSCharter(index)">
            <option value="">Seleccione una opción</option>
            <option v-for="(client, client_index) in psCharterListaClientes" :key="client_index" :value="client.id">
              {{ client.name }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="row.week"
                  :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex"
                  @change="actionSetEditingRowIndexPSCharter(index)">
            <option value="">Seleccione una opción</option>
            <option v-for="(week, week_index) in psCharterCurrentWeeks" :key="week_index" :value="week">
              {{ week }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="row.pod_id"
                  :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex"
                  @change="actionSetEditingRowIndexPSCharter(index)">
            <option value="">Seleccione una opción</option>
            <option v-for="(pod, pod_index) in psCharterListaPuertos" :key="pod_index" :value="pod.id">
              {{ pod.name }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="row.specie_id"
                  :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex"
                  @change="actionSetEditingRowIndexPSCharter(index)">
            <option value="">Seleccione una opción</option>
            <option v-for="(specie, specie_index) in psCharterListaEspecies" :key="specie_index" :value="specie.id">
              {{ specie.name }}
            </option>
          </select>
        </td>
        <td>
          <select class="form-control" v-model="row.pallet_id"
                  :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex"
                  @change="actionSetEditingRowIndexPSCharter(index)">
            <option value="">Seleccione una opción</option>
            <option v-for="(pallet, pallet_index) in psCharterListaPallets" :key="pallet_index" :value="pallet.id">
              {{ pallet.name }}
            </option>
          </select>
        </td>
        <td>
          <input class="form-control" type="text" v-mask="'####'" placeholder="Ingrese una cantidad..."
                 v-model="row.quantity"
                 :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex"
                 @keydown="actionSetEditingRowIndexPSCharter(index)" />
        </td>
        <td>
          <div class="text-center">

            <button class="btn btn-sm icono"
                    @click="updateWeeklyPlan(row)"
                    :disabled="psCharterEditingRowIndex === null || index !== psCharterEditingRowIndex">
              <i title="Guardar cambios" class="fa fa-save" style="text-align: center; font-size: 11.7px;"></i>
            </button>

            <button v-if="index === psCharterEditingRowIndex"
                    class="btn btn-sm icono"
                    @click="actionSetEditingRowIndexPSCharter(), resetEditingRow()">
              <i title="Cancelar cambios" class="fas fa-undo" style="text-align: center; font-size: 11.7px;"></i>
            </button>

            <button class="btn btn-sm icono"
                    @click="deleteWeeklyPlan(row.week_id)"
                    :disabled="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex">
              <i title="Eliminar" class="fa fa-times"
                 v-bind:class="psCharterEditingRowIndex !== null && index !== psCharterEditingRowIndex ? '': 'text-danger'"
                 style="text-align: center; font-size: 11.7px;"></i>
            </button>

            <i v-if="index === psCharterEditingRowIndex"
               title="Cambios pendientes"
               class="p-2 fas fa-circle text-success"
               style="cursor: pointer; text-align: center; font-size: 11.7px;">
            </i>

          </div>
        </td>
      </tr>
    </template>
    </tbody>
  </table>
</template>
<script>
import { mapActions, mapState } from "vuex";

import $ from "jquery";
import FieldsetComponent from "@/components/common/FieldsetComponent.vue";
import {
  actualizarPlanificacionSemanal,
  crearPlanificacionSemanal,
  eliminarPlanificacionSemanal
} from "@/constants/charter";

export default {
  components: { FieldsetComponent },
  data() {
    return {
      loading: true,
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
        paginate: {
          first: "Primero",
          last: "Último",
          next: "Siguiente",
          previous: "Anterior"
        }
      },
      nombreTabla: "id_tabla_" + this.idtabla,
      //datos formulario
      route_model: "",
      client_model: "",
      week_model: "",
      port_model: "",
      specie_model: "",
      pallet_model: "",
      quantity_model: ""
    };
  },
  props: {
    data: Array,
    headers: Array, // Titulos para cabecera de la tabla
    currentWeeks: Array,
    acciones: Array, // Array de configuraciones para botones de la columna "Acciones"
    paginacion: Boolean, // Si la tabla tedra activa la opción de paginación, esta opción esta deshabilitada por defecto
    max: { type: Number, default: 10 }, // Numero de filas por cada pagina
    buscar: Boolean, // Filtrar filas, esta opción esta deshabilitada por defecto
    idtabla: {
      type: String,
      default: "id_generico"
    }
  },
  computed: {
    ...mapState("charter", [
        "psCharterListaEspecies",
        "psCharterListaPallets",
        "psCharterListaClientes",
        "psCharterListaPuertos",
        "psCharterCurrentWeeks",
        "psCharterCurrentWeek",
        "psCharterDataDatatableDetail",
        "psCharterDataDatatableDetailFiltrada",
        "psCharterCreateMode",
        "psCharterCurrentRegion",
        "psCharterEditingRowIndex"
      ]
    ),
    ...mapState(["zIndexModal", "zIndexTablaModal"])
  },
  methods: {
    // Acciones de Vuex
    ...mapActions(["ActionSetLoading"]),
    ...mapActions("charter", [
      "actionSetDataPSCharter",
      "actionSetCreateModePSCharter",
      "actionSetEditingRowIndexPSCharter"
    ]),
    //funciones crud
    async saveNewPlan() {

      if (!this.client_model) {
        return this.$vToastify.error("Por favor, seleccione un cliente", "Error: Cliente");
      }

      if (this.week_model === "") {
        return this.$vToastify.error("Por favor, seleccione una semana", "Error: Semana");
      }

      if (this.port_model === "") {
        return this.$vToastify.error("Por favor, seleccione un POD", "Error: POD");
      }

      if (this.specie_model === "") {
        return this.$vToastify.error("Por favor, seleccione una especie", "Error: Especie");
      }

      if (this.pallet_model === "") {
        return this.$vToastify.error("Por favor, seleccione un tipo de pallet", "Error: Pallet");
      }

      if (this.quantity_model === "") {
        return this.$vToastify.error("Por favor, ingrese la cantidad de pallets o contenedores para el plan", "Error: Cantidad plan");
      }

      const data = {
        route_id: this.psCharterCurrentRegion[0],
        client_id: this.client_model.id,
        week: this.week_model,
        pod_id: this.port_model,
        specie_id: this.specie_model,
        pallet_id: this.pallet_model,
        quantity: this.quantity_model
      };

      this.$vToastify.loader("Espere por favor...");

      this.actionSetEditingRowIndexPSCharter(-1);

      let response = await crearPlanificacionSemanal(data);

      if (response.code === 200) {

        this.clearForm();

        this.actionSetCreateModePSCharter(false);

        this.$vToastify.success("Planificación para la semana " + this.week_model + " almacenada con éxito", "¡Éxito!");

        await this.actionSetDataPSCharter();

      } else if (response.code && response.errors) {

        Object.values(response.errors).forEach(errorArray => {
          errorArray.forEach(error => {
            this.$vToastify.error(error, "Error");
          });
        });

      } else {
        this.$vToastify.error("Error al guardar la planificación para la semana " + this.week_model, "Error");
      }

      this.actionSetEditingRowIndexPSCharter(null);

      this.$vToastify.stopLoader();
    },
    async updateWeeklyPlan(data) {

      if (data.client_id === "") {
        return this.$vToastify.error("Por favor, seleccione un cliente", "Error: Cliente");
      }

      if (data.week === "") {
        return this.$vToastify.error("Por favor, seleccione una semana", "Error: Semana");
      }

      if (data.pod_id === "") {
        return this.$vToastify.error("Por favor, seleccione un POD", "Error: POD");
      }

      if (data.specie_id === "") {
        return this.$vToastify.error("Por favor, seleccione una especie", "Error: Especie");
      }

      if (data.pallet_id === "") {
        return this.$vToastify.error("Por favor, seleccione un tipo de pallet", "Error: Pallet");
      }

      if (data.quantity === "") {
        return this.$vToastify.error("Por favor, ingrese la cantidad de pallets o contenedores para el plan", "Error: Cantidad plan");
      }

      this.$vToastify.loader("Espere por favor...");

      this.actionSetEditingRowIndexPSCharter(-1);

      let response = await actualizarPlanificacionSemanal(data);

      if (response.code === 200) {

        this.$vToastify.success("Planificación para la semana " + this.week_model + " almacenada con éxito", "¡Éxito!");

        await this.actionSetDataPSCharter();

      } else if (response.code && response.errors) {

        Object.values(response.errors).forEach(errorArray => {
          errorArray.forEach(error => {
            this.$vToastify.error(error, "Error");
          });
        });

      } else {

        this.$vToastify.error("Error al guardar la planificación para la semana " + this.week_model, "Error");

      }

      this.actionSetEditingRowIndexPSCharter(null);

      this.$vToastify.stopLoader();
    },
    async deleteWeeklyPlan(id) {

      this.$vToastify.prompt({
        body: "¿Está seguro(a) de que desea eliminar esta planificación semanal?",
        answers: {
          "Sí": true,
          "No": false
        }
      }).then(async value => {
        if (value) {

          this.$vToastify.loader("Espere por favor...");

          this.actionSetEditingRowIndexPSCharter(-1);

          let response = await eliminarPlanificacionSemanal({ week_id: id });

          if (response.code === 200) {

            this.$vToastify.success("Planificación semanal eliminada con éxito", "¡Éxito!");

            await this.actionSetDataPSCharter();

          } else if (response.code && response.errors) {

            Object.values(response.errors).forEach(errorArray => {
              errorArray.forEach(error => {
                this.$vToastify.error(error, "Error");
              });
            });

          } else {

            this.$vToastify.error("Error al eliminar la planificación semanal", "Error");

          }

          this.actionSetEditingRowIndexPSCharter(null);

          this.$vToastify.stopLoader();
        }

      });

    },
    clearForm() {
      this.client_model = "";
      this.week_model = "";
      this.port_model = "";
      this.specie_model = "";
      this.pallet_model = "";
      this.quantity_model = "";
    },
    cancelNewPlan() {
      this.clearForm();
      this.actionSetCreateModePSCharter(false);
    },
    async resetEditingRow() {
      await this.actionSetEditingRowIndexPSCharter(-1);
      await this.actionSetDataPSCharter();
    },
    //metodos miselaneos
    configuracionDatatable() {
      let me = this;

      $("#" + this.nombreTabla)
        .DataTable()
        .destroy();

      $("#" + me.nombreTabla)
        .DataTable({
          paging: this.paginacion,
          pageLength: this.max,
          searching: this.buscar,
          lengthChange: false,
          ordering: true,
          info: true,
          autoWidth: false,
          responsive: true,
          checkd: false,
          language: me.lang
        })
        .buttons()
        .container()
        .appendTo("#" + me.nombreTabla + "_wrapper .col-md-6:eq(0)");
    }
  },
  mounted() {
    let me = this;
    me.configuracionDatatable();
  },
  watch: {
    data: function(_new) {
      let me = this;

      if (_new) {

        $("#" + this.nombreTabla)
          .DataTable()
          .destroy();

        setTimeout(() => {
          me.data = _new;
        }, 300);

        setTimeout(() => {
          me.configuracionDatatable();
          me.ActionSetLoading(false);
        }, 700);
      }
    },
    psCharterCurrentWeek: function(_new) {
      this.week_model = _new;
    },
    psCharterCreateMode: function(_new) {
      if (_new) {
        this.week_model = this.psCharterCurrentWeek;
      } else {
        this.clearForm();
      }
    }
  }
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}

thead > th {
  font-size: 13px !important;
  font-weight: 700;
}

tbody > th {
  font-size: 13px !important;
  font-weight: 700;
}

.hide-button-excel {
  display: none;
}

.buttons-colvis {
  background-color: #dc3545;
  color: #ffff;
  padding: 6px;
  border: none;
  border-radius: 3px;
  font-size: 15px;
}

.buttons-colvis:hover {
  background-color: #bd2130;
  border: none;
}

div.dataTables_wrapper div.dataTables_info {
  font-size: 13px !important;
}

.icono {
  opacity: 0.7;
}

.icono:hover {
  opacity: 1;
}

.btn-group-sm > .btn,
.btn-sm {
  padding: 0.25rem 0.45rem !important;
}

/* Table compact */

table.dataTable.compact thead th,
table.dataTable.compact thead td {
  padding: 3px 5px;
}

table.dataTable.compact tfoot th,
table.dataTable.compact tfoot td {
  padding: 3px;
}

table.dataTable.compact tbody th,
table.dataTable.compact tbody td {
  padding: 3px;
}

/* Table Hover */

table.dataTable.hover > tbody > tr:hover > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.087) !important;
}

/* Stripe (Pintado de tabla estilo cebra) */

table.dataTable.stripe > tbody > tr.odd > *,
table.dataTable.display > tbody > tr.odd > * {
  box-shadow: inset 0 0 0 9999px rgba(0, 0, 0, 0.048);
}

/*  */

table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > th.sorting_asc,
table.dataTable thead > tr > th.sorting_desc,
table.dataTable thead > tr > th.sorting_asc_disabled,
table.dataTable thead > tr > th.sorting_desc_disabled,
table.dataTable thead > tr > td.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting_asc_disabled,
table.dataTable thead > tr > td.sorting_desc_disabled {
  cursor: pointer;
  position: relative;
  padding: 10px 0 !important;
  text-align: center;
}
</style>